import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'

import activities from 'src/store/modules/activities'
// reducers
// TODO get rid of redux
import auth from 'src/store/modules/auth'
import common from 'src/store/modules/common'
import company from 'src/store/modules/company'
import patient from 'src/store/modules/patient'
import referral from 'src/store/modules/referral'
import tasks from 'src/store/modules/tasks'

const store = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    activities,
    common,
    patient,
    tasks,
    company,
    referral
  })

export default store
